import { createCandyMachineV2Builder } from './operations/createCandyMachineV2.mjs';
import { deleteCandyMachineV2Builder } from './operations/deleteCandyMachineV2.mjs';
import { insertItemsToCandyMachineV2Builder } from './operations/insertItemsToCandyMachineV2.mjs';
import { mintCandyMachineV2Builder } from './operations/mintCandyMachineV2.mjs';
import { updateCandyMachineV2Builder } from './operations/updateCandyMachineV2.mjs';

/**
 * This client allows you to access the underlying Transaction Builders
 * for the write operations of the Candy Machine module.
 *
 * @see {@link CandyMachinesV2Client}
 * @group Module Builders
 */
class CandyMachinesV2BuildersClient {
  constructor(metaplex) {
    this.metaplex = metaplex;
  }

  /** {@inheritDoc createCandyMachineV2Builder} */
  create(input, options) {
    return createCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc deleteCandyMachineV2Builder} */
  delete(input, options) {
    return deleteCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc insertItemsToCandyMachineV2Builder} */
  insertItems(input, options) {
    return insertItemsToCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc mintCandyMachineV2Builder} */
  mint(input, options) {
    return mintCandyMachineV2Builder(this.metaplex, input, options);
  }

  /** {@inheritDoc updateCandyMachineV2Builder} */
  update(input, options) {
    return updateCandyMachineV2Builder(this.metaplex, input, options);
  }
}

export { CandyMachinesV2BuildersClient };
//# sourceMappingURL=CandyMachinesV2BuildersClient.mjs.map
